import { SupportingContent, type SupportingContentProps } from "@wayflyer/flyui";
import type { IntlShape } from "react-intl";

import { useApplicationSummaryList } from "../../supporting-content";

export interface OfferOverViewProps {
  supportingLinks: SupportingContentProps["supportingLinks"];
  intl: IntlShape;
}

export const SecondaryContentOfferOverview = ({ intl, supportingLinks }: OfferOverViewProps) => {
  const { amount, expiry } = useApplicationSummaryList();

  return (
    <SupportingContent
      summaryList={
        amount || expiry
          ? {
              heading: intl.formatMessage({ id: "offer review table column", defaultMessage: "Your application" }),
              items: [
                ...(amount
                  ? [
                      {
                        label: intl.formatMessage({
                          id: "contracts overview: application amount label",
                          defaultMessage: "Amount",
                        }),
                        content: amount,
                      },
                    ]
                  : []),
                ...(expiry
                  ? [
                      {
                        label: intl.formatMessage({
                          id: "contracts overview: application expiry label",
                          defaultMessage: "Expires",
                        }),
                        content: expiry,
                      },
                    ]
                  : []),
              ],
            }
          : undefined
      }
      supportingLinks={supportingLinks}
    />
  );
};
